import { render } from "./AddSignatureModal.vue?vue&type=template&id=b7427d4c&scoped=true"
import script from "./AddSignatureModal.vue?vue&type=script&lang=js"
export * from "./AddSignatureModal.vue?vue&type=script&lang=js"

import "./AddSignatureModal.vue?vue&type=style&index=0&id=b7427d4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7427d4c"]])

export default __exports__